import React, { useEffect, useRef, useState } from 'react';

import { InformationTooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { OfferCard } from '../../components/OfferCard';
import { PskTooltipContent } from '../../components/PskTooltipContent';
import { IOffer } from '../../types';
import { ActionsContainer } from '../ActionsContainer';

import { useScrollStopOnView } from '../../../common/hooks/useScrollStopOnView/useScrollStopOnView';
import { ETestIds } from '../../constants';
import { IOfferForAnalytic } from '../../utils/tracking/types';
import { useTracking } from '../../utils/tracking/useTracking';
import * as styles from './styles.css';

export interface IDesktopListingContainerProps {
  onCardClick: (offer: IOffer) => () => void;
  offerList: IOffer[];
  offerListForAnalytics: IOfferForAnalytic[];
}

export const DesktopListingContainer: React.FC<IDesktopListingContainerProps> = ({
  onCardClick,
  offerList,
  offerListForAnalytics,
}) => {
  const { trackShowOffers, trackClickPskTooltip } = useTracking();
  const [isTracked, setIsTracked] = useState(false);
  const listingRef = useRef<HTMLDivElement | null>(null);

  useScrollStopOnView(listingRef, {
    onStop: () => {
      trackShowOffers(offerListForAnalytics);
      setIsTracked(true);
    },
    threshold: 0.5,
  });

  useEffect(() => {
    if (isTracked) {
      trackShowOffers([]);
    }

    return;
  }, []);

  const handleTooltipClick = () => {
    trackClickPskTooltip();
  };

  return (
    <div ref={listingRef} data-testid={ETestIds.DesktopListing}>
      <div className={styles['heading']}>
        <div className={styles['heading__wrapper']}>
          <div className={styles['tooltip__container']}>
            <UIText2 color={'text-secondary-default'}>Полная стоимость кредита</UIText2>
            <div onClick={e => e.stopPropagation()}>
              <InformationTooltip
                placement={'right-start'}
                content={<PskTooltipContent />}
                header={'Полная стоимость кредита'}
                onOpen={handleTooltipClick}
              >
                <div className={styles['tooltip']} data-testid={ETestIds.PskTooltip}>
                  <IconFunctionalInformationCircle16 color={'icon-secondary-default'} cursor="pointer" />
                </div>
              </InformationTooltip>
            </div>
          </div>
          <UIText2 color={'text-secondary-default'}>Ставка</UIText2>
          <UIText2 color={'text-secondary-default'}>Платёж</UIText2>
        </div>
      </div>
      <div>
        {offerList.map((offer, index) => {
          return (
            <div key={index} className={styles['listing__card']}>
              <OfferCard offer={offer} onClick={onCardClick(offer)} />
            </div>
          );
        })}
      </div>
      <ActionsContainer />
    </div>
  );
};
